import { render, staticRenderFns } from "./InvoiceDocumentLink.vue?vue&type=template&id=6f3188b7&"
import script from "./InvoiceDocumentLink.vue?vue&type=script&lang=js&"
export * from "./InvoiceDocumentLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports